import { useTheme } from "styled-components";
import React from "react";
import { Box } from "../../Box";
import { DefaultTableBody as DefaultTableBodyV2 } from "../../TableV2/components/DefaultTableBody";
import { SimpleHeader as SimpleHeaderV2 } from "../../TableV2/components/SimpleHeader";
import { Table as TableV2 } from "../../TableV2/components/Table";
import { useTableV2 } from "../../TableV2/hooks/useTableV2";
export const PopoverContents = ({ columns, pieData }) => {
    const theme = useTheme();
    const table = useTableV2({
        columns,
        data: pieData || [],
    });
    return (React.createElement(Box, { "data-testid": "popoverContents", sx: { boxShadow: theme.shadows.floatingBox } },
        React.createElement(TableV2, { "data-testid": "popoverContentsTable", setColumnOrder: table.setColumnOrder, width: "100%" },
            React.createElement(SimpleHeaderV2, { "data-testid": "popoverContentsTableHeader", enableDnD: false, table: table }),
            React.createElement(DefaultTableBodyV2, { "data-testid": "popoverContentsTableBody", noRowAlternateColors: true, solidColorRowHover: true, table: table }))));
};
